var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9 11.9996C21.9 17.4672 17.4676 21.8996 12 21.8996M21.9 11.9996C21.9 6.53199 17.4676 2.09961 12 2.09961M21.9 11.9996H2.10001M12 21.8996C6.53239 21.8996 2.10001 17.4672 2.10001 11.9996M12 21.8996C14.1539 21.8996 15.9 17.4672 15.9 11.9996C15.9 6.53199 14.1539 2.09961 12 2.09961M12 21.8996C9.8461 21.8996 8.10001 17.4672 8.10001 11.9996C8.10001 6.53199 9.8461 2.09961 12 2.09961M2.10001 11.9996C2.10001 6.53199 6.53239 2.09961 12 2.09961",
    stroke: "#403D3D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.d18ba196f125d3343f3bd6ec74ad6752.svg";
export { ForwardRef as ReactComponent };